import ajax from '@/resources/myApi';

const settingService = {
  getAll,
  getById,
  update,
  create
};

function getAll() {
  return ajax
    .get('api/setting', {
      name: 'settingss'
    })
    .then(result => result);
}

function getById(id) {
  return ajax
    .get('api/setting/' + id, {
      name: 'setting'
    })
    .then(result => result);
}

function update(data) {
  return ajax
    .put('api/setting/' + data.key, {
      name: 'setting',
      body: data.setting
    })
    .then(result => result);
}

function create(body) {
  return ajax
    .post('api/setting/create', {
      name: 'setting',
      body
    })
    .then(result => result)
    .catch(err => Promise.reject(err));
}

export default settingService;
